import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @mui
import { ScopedCssBaseline } from "@mui/material";
import { createTheme, ThemeProvider as MUIThemeProvider } from "@mui/material/styles";
import { useMemo } from "react";
import { isNotUndefinedOrNull } from "../FunctionsCore";
import componentsOverride from "./overrides";
//
import { palette } from "./palette";
import typography from "./typography";
// eslint-disable-next-line import/no-default-export, @typescript-eslint/explicit-module-boundary-types, react/function-component-definition
export default function ThemeProvider({ children, overRidePalette }) {
    const themeOptions = useMemo(() => ({
        "palette": isNotUndefinedOrNull(overRidePalette) ? overRidePalette : palette,
        "typography": typography,
    }), []);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const theme = createTheme(themeOptions);
    theme.components = componentsOverride(theme);
    return (_jsxs(MUIThemeProvider, Object.assign({ theme: theme }, { children: [_jsx(ScopedCssBaseline, {}), children] })));
}
